import { useEffect, useState } from 'react'

/**
 * Bumps a counter when content-data.js fires a data-updated event,
 * forcing Dexie useLiveQuery to re-evaluate since it can't detect
 * IndexedDB writes from the content script's isolated world.
 */
export function useDataVersion() {
  const [version, setVersion] = useState(0)
  useEffect(() => {
    const handler = () => setVersion((v) => v + 1)
    window.addEventListener('fwdslash-data-updated', handler)
    return () => window.removeEventListener('fwdslash-data-updated', handler)
  }, [])
  return version
}
